import { useMutation } from "@tanstack/react-query";
import { reporting_api_requests } from ".";
import { EventIngestionRequest, EventIngestionResponse } from "./types";

const EVENTS_PATH = "/events";

/**
 * Hook for sending a single event to the backend
 */
export const useIngestEvent = () => {
  return useMutation({
    mutationFn: async (request: EventIngestionRequest) => {
      const response = await reporting_api_requests.post<
        EventIngestionResponse,
        EventIngestionRequest
      >(EVENTS_PATH, request);
      return response;
    },
    // Fail silently in production to avoid disrupting user experience
    onError: (error) => {
      console.error("Failed to ingest tracking event:", error);
    },
  });
};

/**
 * Direct API call for use outside of React components
 */
export const reportingApi = {
  ingest: async (
    request: EventIngestionRequest
  ): Promise<EventIngestionResponse> => {
    const response = await reporting_api_requests.post<
      EventIngestionResponse,
      EventIngestionRequest
    >(EVENTS_PATH, request);
    return response;
  },
};
